let mode =true

function getMode(){
    return mode
}

function setMode(a){
    mode = a
}

module.exports={
    getMode,
    setMode
}